export default (id: string | number) => id.toString().startsWith('gid://shopify/');
